import { Box, TextField } from "@mui/material";
import styled from "styled-components";
import theme from "../../../styles/theme";

export const ContainerSearch = styled(Box)`
  && {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0 24px; /* Adiciona um espaçamento lateral em telas menores */
    @media ${theme.devices.tablet} {
      padding: 0px;
    }
  }
`;

export const TextFieldStyled = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      font-family: var(--font-sans);
      height: 48px;
      border-radius: 24px; /* Bordas arredondadas estilo Google */
      background-color: #f1f3f4; /* Fundo cinza claro */
      transition: background-color 0.2s ease, box-shadow 0.2s ease;

      /* Remove a borda padrão do Material-UI */
      & .MuiOutlinedInput-notchedOutline {
        border: none;
      }

      &:hover {
        background-color: #E2E6EA;
        box-shadow: 0 1px 6px rgba(32, 33, 36, 0.1);
      }

      /* Adiciona sombra quando focado */
      &.Mui-focused {
        background-color: #fff;
        box-shadow: 0 1px 6px rgba(32, 33, 36, 0.2);
      }

      &.Mui-disabled {
        background-color: #f1f3f4;
        opacity: 0.7;
      }
    }

    input {
      color: #1F1F1F; /* Cor do texto */
    }

    input::placeholder {
      color: #5f6368; /* Cor do placeholder */
      opacity: 1;
    }
  }
`;
